import { Tooltip } from 'bootstrap';
import React from 'react';
import { PieChart, Pie } from 'recharts';
import useChart from '../../hooks/useChart';

const MyPieChart = () => {
    const [data, setData] = useChart()
    console.log(setData);
    return (
        <div>
            <PieChart height={400} width={400}>
                <Pie data={data} dataKey={'investment'} cx="50%" cy="50%" outerRadius={80} fill="#8884d8" />
                <Pie data={data} dataKey={'revenue'} cx="50%" cy="50%" innerRadius={90} outerRadius={120} fill="#82ca9d" label />

            </PieChart>
            <h5 className='text-center'>Investment(blue) vs Revenue(green)</h5>
        </div>


    )
};

export default MyPieChart;